import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

/**
 * Wrapper per compatibilità con React Router v6
 * Sostituisce il withRouter rimosso in v6
 * Una volta che tutti i componenti con classi saranno convertiti in funzionali, questo wrapper può essere rimosso.
 */
export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return (
      <Component
        {...props}
        location={location}
        navigate={navigate}
        params={params}
        // Compatibilità con v5 history API
        history={{
          push: navigate,
          replace: to => navigate(to, { replace: true }),
          go: n => navigate(n),
          goBack: () => navigate(-1),
          goForward: () => navigate(1),
        }}
        // Compatibilità con v5 match API
        match={{ params }}
      />
    );
  }

  // Preserva il displayName per debugging
  const displayName = Component.displayName || Component.name || 'Component';
  ComponentWithRouterProp.displayName = `withRouter(${displayName})`;

  return ComponentWithRouterProp;
}

export default withRouter;
